//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Navigation from '@/components/sobre/NewNavigation.vue';
import Headline from '@/components/sobre/NewHeadline.vue';
import Information from './components/Information';
import Directions from './components/Directions';
import Advantages from './components/Advantages';
import Partners from './components/Partners';
import Places from './components/Places';

export default {
  name: 'AboutUs',
  components: {
    Headline,
    Navigation,
    Information,
    Directions,
    Advantages,
    Places,
    Partners,
  },
  layout: 'scaled',
  head() {
    return {
      bodyAttrs: {
        class: 'about-us',
      },
      title: this.$t('meta.aboutUs.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.aboutUs.description'),
        },
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: `https://${this.$app.config.current.domain}${this.$route.path}`,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.$t('meta.aboutUs.title'),
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('meta.aboutUs.description'),
        },
        {
          hid: 'og:type',
          name: 'og:type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: `https://${
            this.$store?.state?.host
          }${require(`~/assets/${this.$app?.config?.common?.currentCountry}/ebac-logo.png`)}`,
        },
      ],
    };
  },
};
